import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { forwardRef } from 'react';
import { cn } from "../lib/cn.js";
import { VisuallyHidden } from "./feedback.js";
/**
 * Uma gaveta que entra pela lateral — F132.
 *
 * Existe para o menu lateral no celular e no tablet, onde uma barra fixa de
 * 224px come metade da tela. É o `Dialog` do Radix por baixo — foco preso, Esc
 * fecha, a rolagem do fundo trava — com outra forma: presa à borda, na altura
 * inteira da janela, sem cabeçalho visível.
 *
 * O título é obrigatório e fica só para o leitor de tela: uma gaveta sem nome
 * é anunciada como "diálogo" e mais nada.
 */
export const Sheet = DialogPrimitive.Root;
export const SheetTrigger = DialogPrimitive.Trigger;
export const SheetClose = DialogPrimitive.Close;
export const SheetContent = forwardRef(({ title, side = 'left', className, children, ...props }, ref) => (_jsxs(DialogPrimitive.Portal, { children: [_jsx(DialogPrimitive.Overlay, { className: cn('fixed inset-0 z-(--z-overlay) bg-(--surface-overlay)', 'data-[state=open]:animate-in data-[state=open]:fade-in-0', 'data-[state=closed]:animate-out data-[state=closed]:fade-out-0') }), _jsxs(DialogPrimitive.Content, { ref: ref, "aria-describedby": undefined, className: cn('fixed top-0 z-(--z-dialog) flex h-[100dvh] w-72 max-w-[85vw] flex-col bg-(--surface-raised) shadow-(--shadow-lg)', side === 'left' ? 'left-0' : 'right-0', 'data-[state=open]:animate-in data-[state=closed]:animate-out', side === 'left'
                ? 'data-[state=open]:slide-in-from-left data-[state=closed]:slide-out-to-left'
                : 'data-[state=open]:slide-in-from-right data-[state=closed]:slide-out-to-right', className), ...props, children: [_jsx(VisuallyHidden, { children: _jsx(DialogPrimitive.Title, { children: title }) }), children] })] })));
SheetContent.displayName = 'SheetContent';
//# sourceMappingURL=sheet.js.map